export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/audiobook_production.f1ec332.svg";